import { PLACES_TOKEN } from '../config/credentials.js';

const tzEndpoint = 'https://maps.googleapis.com/maps/api/timezone/json';
const mapsGeocodeEndpoint = 'https://maps.googleapis.com/maps/api/geocode/json';
const getTimeZoneFromLocation = async ([lat, lng]) => {
  const locationParams = `location=${lat},${lng}`;
  const timestampParams = `timestamp=${Math.floor(Date.now() / 1000)}`;
  const keyParams = `key=${PLACES_TOKEN}`;
  const requestUrl = `${tzEndpoint}?${locationParams}&${timestampParams}&${keyParams}`;
  const response = await fetch(requestUrl);
  const data = await response.json();
  return data;
};
const getFullLocationObject = async locationObject => {
  const {
    lat,
    lng
  } = locationObject;
  const locationParams = `latlng=${lat},${lng}`;
  const keyParams = `key=${PLACES_TOKEN}`;
  const requestUrl = `${mapsGeocodeEndpoint}?${locationParams}&${keyParams}`;
  const response = await fetch(requestUrl);
  const data = await response.json();
  const {
    results
  } = data;

  if (!results.length) {
    throw Error('No matching address result found for lat-lng pair');
  }

  const firstResult = results[0];
  const {
    timeZoneId: timeZone
  } = await getTimeZoneFromLocation([lat, lng]);
  const reformedLocationObject = Object.assign(Object.assign({}, locationObject), {
    formattedAddress: firstResult === null || firstResult === void 0 ? void 0 : firstResult.formatted_address,
    addressComponents: firstResult === null || firstResult === void 0 ? void 0 : firstResult.address_components,
    timeZone
  });
  return reformedLocationObject;
};
const LAT_DEGREE_FT = 364000;
const LNG_DEGREE_FT = 288200;
/**
 * Determine the deviation between two lat, lng pair points in feet
 */

const getLatLngDeviationInFt = (loc0, loc1) => {
  const {
    lat: lat0,
    lng: lng0
  } = loc0;
  const {
    lat: lat1,
    lng: lng1
  } = loc1;
  const latDiffDeg = lat1 - lat0;
  const lngDiffDeg = lng1 - lng0;
  const latDiffFt = latDiffDeg * LAT_DEGREE_FT;
  const lngDiffFt = lngDiffDeg * LNG_DEGREE_FT;
  return Math.sqrt(Math.pow(latDiffFt, 2) + Math.pow(lngDiffFt, 2));
};
/**
 * Determine the deviation between two lat, lng pair points in miles
 */

const getLatLngDeviationInMiles = (loc0, loc1) => {
  const deviationInFt = getLatLngDeviationInFt(loc0, loc1);
  return deviationInFt / 5280;
};

export { getFullLocationObject, getLatLngDeviationInFt, getLatLngDeviationInMiles, getTimeZoneFromLocation };
